import { createApiClient } from "../../helpers/api-client";

/**
 * Create a PDQ (Product Discovery Queue) API client.
 *
 * @param {string} csrf - The CSRF token for authentication.
 * @returns {{ fetchAddProduct: (productId: string | number) => Promise<any>, fetchRemoveProduct: (productId: string | number) => Promise<any> }} The PDQ API methods.
 */
export default function createPdqApi(csrf) {
    const api = createApiClient(csrf);

    return {
        /**
         * Add a product to the discovery queue.
         *
         * @param {string | number} productId - The product ID to add.
         * @returns {Promise<any>} The API response.
         */
        async fetchAddProduct(productId) {
            return await api(
                `/discovery-queues/add-product/${productId}`,
                "GET",
            );
        },
        /**
         * Remove a product from the discovery queue.
         *
         * @param {string | number} productId - The product ID to remove.
         * @returns {Promise<any>} The API response.
         */
        async fetchRemoveProduct(productId) {
            return await api(
                `/discovery-queues/remove-product/${productId}`,
                "GET",
            );
        },
    };
}
